.selectionRowAndNotice {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.selectionRow {
    display: flex;
    flex-direction: row;
    gap: 12px;
    width: 100%;
}

.selection {
    flex: 1;
}

.saveButtons {
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: end;
    margin-top: 10px;
}

.container {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.circleRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
}

.aiReviewMetadata {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
}

.aiReviewComments {
    margin-top: 12px;
}

.summitGuideGenerationStatus {
    margin-bottom: 12px;
}
